import { Box, Flex, StyleProps } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ChevronLeftOutline, ChevronRightOutline } from '@bonusly/ds-icon';
import { Text } from '@bonusly/ds-typography';

import { useMonthSelectorContext } from './month-selector-context';

type MonthSelectorControlsProps = StyleProps;

// Controls to navigate through years and displays the current year.
export const MonthSelectorControls: FC<MonthSelectorControlsProps> = (props) => {
	const { t } = useTranslation('components');
	const { onPrevYear, onNextYear, currentYear } = useMonthSelectorContext();

	return (
		<Flex justifyContent="space-between" alignItems="center" mb={3} {...props}>
			<Box aria-label={t('date_picker.previous_year')} as="button" onClick={onPrevYear} type="button">
				<ChevronLeftOutline />
			</Box>

			<Text variant="strong">{currentYear}</Text>

			<Box aria-label={t('date_picker.next_year')} as="button" onClick={onNextYear} type="button">
				<ChevronRightOutline />
			</Box>
		</Flex>
	);
};
